import React, { useEffect, useRef } from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { LOGO_INPUT_ACCEPT } from 'swag-client-common/utils/constants';
import { Button } from 'swag-client-common/components/ui/button';
import computerIcon from 'assets/svg/computer.svg';
import Loading from 'swag-client-common/components/info/loading';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { LogoItem } from '../company-art-folder-all-logos-popup/components/logo-item';
import css from './company-art-folder-popup.scss';
const classes = {
  paper: css.paper
};
const titleClasses = {
  root: css.header
};
export function CompanyArtFolderPopupComponent(props) {
  const {
    open,
    logosList,
    showMoreBtn,
    view,
    isLoading,
    onClose,
    updateLogoPagination,
    loadMoreLogos,
    onSelectLogo,
    onRemoveLogo,
    onUploadLogo,
    onOpenMore
  } = props;
  useEffect(() => {
    if (open && !isLoading) {
      updateLogoPagination();
      loadMoreLogos();
    }
  }, [open]);
  const inputRef = useRef(null);
  const handleInputChange = event => {
    var _event$target, _event$target$files;
    const file = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$files = _event$target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];
    if (file && view) {
      onUploadLogo(file, view);
    }
  };
  const clickToInput = () => {
    var _inputRef$current;
    return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
  };
  const content = /*#__PURE__*/React.createElement("div", {
    className: css.content
  }, /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, "Hey, how would you like to upload artwork?"), /*#__PURE__*/React.createElement("div", {
    className: css.text
  }, "You can either upload it from your computer or select from your company art folder."), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Button, {
    isButtonTag: false,
    className: css.uploadButton,
    type: "primary",
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, clickToInput)
  }, /*#__PURE__*/React.createElement("div", {
    className: css.buttonText
  }, /*#__PURE__*/React.createElement("img", {
    src: computerIcon,
    alt: "Computer"
  }), /*#__PURE__*/React.createElement("span", null, "Upload From Computer"))), /*#__PURE__*/React.createElement("input", {
    className: css.fileInput,
    accept: LOGO_INPUT_ACCEPT,
    type: "file",
    ref: inputRef,
    onChange: handleInputChange
  })), /*#__PURE__*/React.createElement("div", {
    className: css.subTitle
  }, "Company art folder"), /*#__PURE__*/React.createElement("div", {
    className: css.logosList
  }, isLoading && /*#__PURE__*/React.createElement(Loading, null), !isLoading && logosList.map(logo => /*#__PURE__*/React.createElement(LogoItem, {
    isLastLogo: logosList.length === 1,
    key: logo._id,
    className: css.logoItem,
    logo: logo,
    onClick: onSelectLogo,
    onDelete: onRemoveLogo,
    withShadow: true
  })), showMoreBtn && /*#__PURE__*/React.createElement("div", {
    onClick: onOpenMore,
    className: css.pinkLink,
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, onOpenMore)
  }, "View All")));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: open,
    classes: classes,
    onClose: onClose,
    dataPopup: "CompanyArtFolderPopup",
    content: content,
    titleClasses: titleClasses,
    contentClass: css.contentWrapper,
    closeClass: css.closeClass,
    isResponsive: true
  });
}